const Core = require("mt-react-core");

module.exports = Core